import React from "react";
import './Footer.css';


function Footer(){
    return(
        <div className="footer">
            <div className="footer-upper">
                
                <div className="footer-title">
                    <div className="footer-title-head">
                        <div className="just-one">
                            <div className="just">Just</div>
                            <div className="one">One</div>
                        </div>
                        <div className="click-connect"> Click <span className="footer-and1">&</span> Connect</div>
                    </div>
                    <div className="footer-logo-container">
                        {/* linked in */}
                        <div className="footer-logo">
                        <a href="https://www.linkedin.com/in/mayank-gupta-715210242" target="_blank" rel="noreferrer">

                            <img className="footer-logo-img" alt='footer-logo' src="/Assets/linkedin.svg"></img>
                        </a>
                        </div>

                        {/* github */}
                        <div className="footer-logo">
                            
                        <a href="https://x.com/mayankgupt_a" target="_blank" rel = "noreferrer">

                                <img className="footer-logo-img" alt='footer-logo' src="/Assets/twitter.svg"></img>
                        </a>
                        </div>

                        {/* gmail */}
                        <div className="footer-logo">
                            <a href="mailto:mayank71203@gmail.com">
                                <img className="footer-logo-img" alt='footer-logo' src="/Assets/envelope-solid.svg"></img>
                            </a>
                        </div>

                        {/* instagram */}
                        <div className="footer-logo">
                            <a href="https://www.instagram.com/the_mayankism/" target="_blank" rel = "noreferrer">
                                <img className="footer-logo-img" alt='footer-logo' src="/Assets/instagram.svg"></img>
                            </a>
                        </div>

                        {/* resume */}
                        <div className="footer-logo">
                            <a href='/Assets/Mayank_resume.pdf' target="_blank" rel="noreferrer">

                                <img className="footer-logo-img" alt='footer-logo' src="/Assets/file-solid.svg" ></img>
                            </a>
                        </div>

                    </div>
                    
                </div>
                <div className="footer-content">
                    <span className="footer-content-span1">I am always<br/>
                    ready to collabrate<br/>
                    to build something</span><br/>
                    <span className="footer-content-span2">Wow!!<br/>
                    Amazing <span className="footer-and2">&</span><br/>
                    Innovative</span>
                </div>
            </div>
            <div className="footer-below">
                <div className="footer-below-container">

                    <div className="footer-below-div1"><i>So what are you waiting for? Build with...</i></div>
                    <div className="footer-below-div2">Mayank Gupta</div>
                </div>
            </div>
        </div>
    );
}
export default Footer;